import { DatePicker } from 'antd'
import luxonGenerateConfig from 'rc-picker/lib/generate/luxon'

const CustomDatePicker = DatePicker.generatePicker(luxonGenerateConfig)
const { RangePicker } = CustomDatePicker
const MyRangePicker = RangePicker

export default MyRangePicker
